module.exports = __webpack_public_path__ + "img/help.d4601abf.png";